import {
  getUpgradePackageShelvesJobList,
  resetUpgradePackageJob,
  deleteUpgradePackageJob,
} from '@/services/remoteUpgrade';

export default {
  namespace: 'RemoteUpgrade_upgradePackageJobs',

  state: {
    jobList: [],
    response: '',
  },

  effects: {
    *fetchUpgradePackageShelvesJobList({ payload }, { call, put }) {
      const { status, data } = yield call(
        getUpgradePackageShelvesJobList,
        payload
      );

      if (status === 200) {
        yield put({
          type: 'saveList',
          payload: {
            list: data.data,
            pagination: {
              total: data.meta.total,
              pageSize: parseInt(data.meta.per_page),
              current: data.meta.current_page,
            },
          },
        });
      }
    },
    *reset({ payload }, { call, put }) {
      const { status } = yield call(resetUpgradePackageJob, payload);
      if (status === 201) {
        yield put({
          type: 'saveResponse',
          payload: 204,
        });
      }
    },
    *delete({ payload }, { call, put }) {
      const { status } = yield call(deleteUpgradePackageJob, payload);
      yield put({
        type: 'saveResponse',
        payload: status,
      });
    },
  },

  reducers: {
    saveList(state, { payload }) {
      return {
        ...state,
        jobList: payload,
      };
    },
    saveResponse(state, { payload }) {
      return {
        ...state,
        response: payload,
      };
    },
  },
};
